// pages/not-found.page.jsx
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <>
    <style>{`
      .nf-root { background: #080b0f; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; font-family: 'DM Sans', sans-serif; color: #e8edf3; gap: 16px; }
      .nf-code { font-family: 'DM Mono', monospace; font-size: 72px; font-weight: 700; color: #1a2030; line-height: 1; }
      .nf-title { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 400; }
      .nf-sub { font-size: 14px; color: #718096; font-weight: 300; }
      .nf-link { font-family: 'DM Mono', monospace; font-size: 12px; color: #34d399; text-decoration: none; border: 1px solid rgba(52,211,153,0.3); padding: 8px 20px; border-radius: 8px; margin-top: 8px; transition: background 0.15s; }
      .nf-link:hover { background: rgba(52,211,153,0.08); }
    `}</style>
    <div className="nf-root">
      <p className="nf-code">404</p>
      <h1 className="nf-title">Page not found</h1>
      <p className="nf-sub">This page doesn't exist or has moved.</p>
      <Link to="/" className="nf-link">
        Back to home →
      </Link>
    </div>
  </>
);

export default NotFoundPage;
